import { type ReactNode } from 'react';
import { Button } from 'src/components/Button';
import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';

export function ActionsList({
  actions,
  /** When true (default), stack actions vertically on xs and use full-width buttons for narrow dialogs. */
  responsiveLayout = true,
}: {
  actions: ReactNode | ButtonPropsWithLabel[];
  responsiveLayout?: boolean;
}) {
  if (!Array.isArray(actions)) {
    return <Stack sx={{ width: '100%' }}>{actions}</Stack>;
  }

  return (
    <Stack
      direction={
        responsiveLayout ? { xs: 'column', sm: 'row' } : 'row'
      }
      spacing={1.5}
      alignItems={
        responsiveLayout ? { xs: 'stretch', sm: 'center' } : 'center'
      }
      justifyContent={
        responsiveLayout ? { xs: 'flex-start', sm: 'flex-end' } : 'flex-end'
      }
      sx={{ width: responsiveLayout ? { xs: '100%', sm: 'auto' } : '100%' }}
    >
      {actions.map((buttonProps, i) => {
        const { sx: actionSx, ...buttonRest } = buttonProps;
        const mergedSx = [
          responsiveLayout
            ? {
                alignSelf: { xs: 'stretch', sm: 'auto' },
                width: { xs: '100%', sm: 'auto' },
                minWidth: { sm: 'min-content' },
              }
            : {},
          ...(Array.isArray(actionSx) ? actionSx : actionSx ? [actionSx] : []),
        ];

        return (
          <Button key={buttonProps.label?.toString() ?? i} {...buttonRest} sx={mergedSx}>
            {buttonProps.children || buttonProps.label}
          </Button>
        );
      })}
    </Stack>
  );
}
